import { createIcon } from '@consta/icons/Icon'
import type { FC, SVGProps } from 'react'

const IconResizerArrowM: FC<SVGProps<SVGSVGElement>> = props => {
  return (
    <svg viewBox="0 0 18 6" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_121363_249952)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.105789 0.542317C0.352773 0.0578861 0.953431 -0.138468 1.4474 0.103747L9 3.80715L16.5526 0.103747C17.0466 -0.138468 17.6472 0.0578861 17.8942 0.542317C18.1412 1.02675 17.941 1.61581 17.447 1.85803L9 6L0.552992 1.85803C0.0590255 1.61581 -0.141194 1.02675 0.105789 0.542317Z"
          fill="var(--color-typo-primary)"
          fillOpacity="0.3"
        />
      </g>
      <defs>
        <clipPath id="clip0_121363_249952">
          <rect width="18" height="6" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconResizerArrow = createIcon({
  l: IconResizerArrowM,
  m: IconResizerArrowM,
  s: IconResizerArrowM,
  xs: IconResizerArrowM,
  name: 'IconResizerArrow',
})
